import { Button, ButtonProps, mqUntil, Text } from "@biesse-group/react-components";
import React, { FC } from "react";
import styled, { css } from "styled-components";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  > * {
    flex: 0 1 45%;
  }
  ${mqUntil(
    `sm`,
    css`
      flex-direction: column-reverse;
      gap: 20px;
      > * {
        flex: unset;
      }
    `
  )}
`;

interface CancelButtonProps extends Partial<ButtonProps> {
  label: string;
}

interface ConfirmButtonProps extends Partial<ButtonProps> {
  label: string;
}

export interface FormButtonsProps {
  confirmButton: ConfirmButtonProps;
  cancelButton: CancelButtonProps;
}

export const FormButtons: FC<FormButtonsProps> = ({
  confirmButton: { label: confirmButtonLabel, ...confirmButtonProps },
  cancelButton: { label: cancelButtonLabel, ...cancelButtonProps },
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <ButtonContainer>
        <Button variant="outline-inverted" size="large" {...cancelButtonProps}>
          {cancelButtonLabel}
        </Button>
        <Button variant="primary-inverted" size="large" {...confirmButtonProps}>
          {confirmButtonLabel}
        </Button>
      </ButtonContainer>
      <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
        <Text size="xs" color="light">
          This site is protected by reCAPTCHA and the Google{" "}
          <u>
            <a href="https://policies.google.com/privacy">Privacy Policy</a>
          </u>{" "}
          and{" "}
          <u>
            <a href="https://policies.google.com/terms">Terms of Service</a>
          </u>{" "}
          apply.
        </Text>
      </div>
    </div>
  );
};
